import { combineReducers } from 'redux';

import DailyDeposit from './dailydeposit/reducer';

export default combineReducers({
  DailyDeposit,
});



// WEBPACK FOOTER //
// ./src/pages/dailydeposit/state/reducer.js